// PROTOTYPE PRICING — final services and pricing subject to owner approval.
// All service content is edited here only.

const img = (n) => `/assets/gallery/${n}`;

export const serviceCategories = [
  "All",
  "Braids",
  "Protective Styles",
  "Kids",
  "Natural Hair",
  "Maintenance",
];

export const services = [
  {
    id: "feed-in-braids",
    name: "Feed-In Braids",
    category: "Braids",
    price: 100,
    hairIncluded: true,
    hairNote: "Hair Included",
    duration: "Approx. 3–4 hours",
    short: "Sleek, seamless cornrows with a natural feed-in finish.",
    description:
      "Our signature look. Clean, detailed parts with braiding hair fed in gradually for a flat, natural, long-lasting finish that protects your edges.",
    prep: [
      "Arrive with hair washed, blow-dried and fully detangled",
      "Free of heavy oils and products",
      "Bring inspiration photos if you have a specific design in mind",
    ],
    addons: [
      { name: "Freestyle / design parts", price: 15 },
      { name: "Boho curl add-on", price: 25 },
      { name: "Extra length (past waist)", price: 20 },
    ],
    image: img("g-feedin-1.jpg"),
    featured: true,
  },
  {
    id: "knotless-braids",
    name: "Knotless Braids",
    category: "Braids",
    price: 180,
    hairIncluded: false,
    hairNote: "Hair options vary",
    duration: "Approx. 5–7 hours",
    short: "Lightweight, tension-free box braids that move like your hair.",
    description:
      "A gentler take on box braids — started with your natural hair so there's no knot at the root. Lightweight, painless, and effortlessly versatile.",
    prep: [
      "Arrive with hair washed, blow-dried and fully detangled",
      "Confirm hair color choice at booking",
      "Plan for a longer appointment window",
    ],
    addons: [
      { name: "Boho / goddess pieces", price: 30 },
      { name: "Butt-length upgrade", price: 35 },
      { name: "Beads & accessories", price: 10 },
    ],
    image: img("svc-knotless.jpg"),
    featured: true,
  },
  {
    id: "stitch-braids",
    name: "Stitch Braids",
    category: "Braids",
    price: 120,
    hairIncluded: true,
    hairNote: "Hair Included",
    duration: "Approx. 3–4 hours",
    short: "Crisp horizontal stitch lines for a sharp, sculpted look.",
    description:
      "Precision parting with defined stitch lines — a bold, structured style that photographs beautifully and holds its shape.",
    prep: [
      "Arrive with hair washed, blow-dried and fully detangled",
      "Edges should be free of heavy gel on arrival",
    ],
    addons: [
      { name: "Heart / swirl design", price: 20 },
      { name: "Extra length", price: 20 },
    ],
    image: img("svc-stitch.jpg"),
    featured: true,
  },
  {
    id: "box-braids",
    name: "Box Braids",
    category: "Protective Styles",
    price: 160,
    hairIncluded: false,
    hairNote: "Hair options vary",
    duration: "Approx. 5–7 hours",
    short: "The timeless classic — neat sections, endless styling options.",
    description:
      "Classic individual plaits in clean, even sections. Wear them down, in a bun, or styled up — box braids never miss.",
    prep: [
      "Arrive with hair washed, blow-dried and fully detangled",
      "Confirm size and length at booking",
    ],
    addons: [
      { name: "Boho curls", price: 25 },
      { name: "Triangle parts", price: 15 },
      { name: "Extra length", price: 25 },
    ],
    image: img("svc-box.jpg"),
    featured: true,
  },
  {
    id: "kids-braids",
    name: "Kids Braids",
    category: "Kids",
    price: 80,
    hairIncluded: true,
    hairNote: "Hair Included",
    duration: "Approx. 2–4 hours",
    short: "Gentle, age-appropriate styles with a patient touch.",
    description:
      "Patient, gentle braiding for little ones — cute, neat styles that last for school weeks and picture days.",
    prep: [
      "Arrive with hair washed, blow-dried and fully detangled",
      "Bring snacks and entertainment for longer styles",
      "A parent or guardian must remain reachable",
    ],
    addons: [
      { name: "Beads & bows", price: 10 },
      { name: "Design parts", price: 10 },
    ],
    image: img("g-kids-1.jpg"),
    featured: true,
  },
  {
    id: "cornrows",
    name: "Cornrows",
    category: "Braids",
    price: 75,
    hairIncluded: true,
    hairNote: "Hair Included",
    duration: "Approx. 2–3 hours",
    short: "Clean straight-backs or creative patterns, laid to perfection.",
    description:
      "Straight-back or patterned cornrows with crisp parts and a polished finish — simple, protective, and always sharp.",
    prep: ["Arrive with hair washed, blow-dried and fully detangled"],
    addons: [
      { name: "Design / zigzag parts", price: 15 },
      { name: "Added hair for fullness", price: 15 },
    ],
    image: img("svc-cornrows.jpg"),
    featured: true,
  },
  {
    id: "silk-press",
    name: "Silk Press",
    category: "Natural Hair",
    price: 85,
    hairIncluded: false,
    hairNote: "No braiding hair needed",
    duration: "Approx. 2–3 hours",
    short: "Silky, flowing natural hair with body and shine.",
    description:
      "A wash, deep condition, blowout and precision press that leaves natural hair silky, bouncy and full of movement.",
    prep: ["Come with hair free of heavy product build-up"],
    addons: [
      { name: "Trim", price: 20 },
      { name: "Deep steam treatment", price: 15 },
    ],
    image: img("svc-silk.jpg"),
    featured: false,
  },
  {
    id: "braid-takedown",
    name: "Braid Take-Down & Wash",
    category: "Maintenance",
    price: 40,
    hairIncluded: false,
    hairNote: "Service only",
    duration: "Approx. 1–2 hours",
    short: "Careful removal, cleanse and condition between styles.",
    description:
      "Gentle take-down of your current style followed by a cleanse and condition, so your hair stays healthy between installs.",
    prep: ["Book alongside your next install for a fresh start"],
    addons: [{ name: "Deep condition upgrade", price: 15 }],
    image: img("svc-takedown.jpg"),
    featured: false,
  },
];

export const featuredServices = services.filter((s) => s.featured);
export const getService = (id) => services.find((s) => s.id === id);

